// ============================================================================
// Fichier de configuration central du site — Tamila Hachemi
// Regroupe les éléments amenés à changer souvent (réseaux sociaux, vidéo
// Arte, coordonnées) pour qu'ils soient faciles à mettre à jour en un seul
// endroit, sans avoir à fouiller dans les pages.
// ============================================================================

// --- Réseaux sociaux -------------------------------------------------------
// TODO [À COMPLÉTER] : remplacer "#" par les vraies URLs (Instagram, LinkedIn,
// Facebook...) dès qu'elles seront communiquées. Mettre `enabled: false` pour
// masquer une icône tant que le lien n'est pas prêt.
export const socialLinks = [
  {
    id: "instagram",
    label: "Instagram",
    url: "#", // TODO [À COMPLÉTER] : lien Instagram
    enabled: false,
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    url: "https://www.linkedin.com/in/tamila-hachemi-87a564364/",
    enabled: true,
  },
  {
    id: "facebook",
    label: "Facebook",
    url: "#", // TODO [À COMPLÉTER] : lien Facebook
    enabled: false,
  },
];

// --- Coordonnées ------------------------------------------------------------
// Source unique de vérité pour toutes les coordonnées affichées sur le site
// (pied de page, page contact...).
export const contactInfo = {
  phone: "+33 7 65 60 58 84",
  phoneHref: "tel:+33765605884",
  whatsapp: "+33 7 65 60 58 84",
  whatsappHref: "https://wa.me/33765605884",
  email: "tamilahachemipsychotherapeute@gmail.com",
  address: "2 rue du Beausset, 13001 Marseille, France",
};

// --- Hero de l'accueil -------------------------------------------------------
// Photo de Marseille pour le fond de la section d'en-tête de l'accueil.
export const heroBackgroundImage = "/bandeau-skyline.png";

// --- Vidéo Arte --------------------------------------------------------------
// Les vidéos Arte sont dépubliées après un certain temps : toutes les
// informations liées sont regroupées ici pour être faciles à changer ou à
// retirer.
// Le lecteur Arte embarqué (embeds) n'a pas de paramètre de temps de départ
// documenté : on affiche donc, juste sous le lecteur, une mention indiquant
// que l'extrait commence à 2:52, avec un lien vers la vidéo sur arte.tv.
export const arteVideo = {
  sectionTitle: "Mes valeurs dans la psychothérapie",
  // Code d'intégration officiel Arte — ne pas modifier l'URL du src.
  embedUrl: "https://www.arte.tv/embeds/fr/119121-002-A?autoplay=true&mute=0",
  pageUrl: "https://www.arte.tv/fr/videos/119121-002-A/psycho/",
  iframeTitle: "Psycho",
  // Passage important de l'extrait : 2 minutes 52
  startLabel: "2:52",
  startSeconds: 172,
};
